.path {
  display: grid;
  gap: 8px;
  padding-top: 4px;
}

.facts {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 8px 20px;
  margin: 0;
}

.facts dt {
  font-size: var(--t-min);
  color: var(--muted);
}

.facts dd {
  margin: 2px 0 0;
  font-size: var(--t-dense);
  font-weight: 600;
  color: var(--ink);
}

.warn {
  color: var(--warn);
}

.label {
  margin: 0;
  font-size: var(--t-min);
  color: var(--muted);
}

.head {
  margin: 0 0 4px;
  font-size: var(--t-min);
  font-weight: 650;
  color: var(--ink-2);
}

.list {
  display: grid;
  gap: 2px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.list li {
  display: flex;
  flex-wrap: wrap;
  gap: 2px 12px;
  align-items: baseline;
  font-size: var(--t-dense);
}

.meta {
  font-size: var(--t-min);
  color: var(--muted);
  font-variant-numeric: lining-nums tabular-nums;
}

.next {
  margin: 0;
}

.link {
  display: inline-flex;
  align-items: center;
  min-height: var(--target-min);
  color: var(--accent);
  font-weight: 650;
  text-decoration: none;
}

.link:hover {
  text-decoration: underline;
}
